import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { __SEND_API_LOG } from '../alilog/request';


const showStatus = (status: number) => {
    let message = ''
    switch (status) {
        case 400:
            message = '请求错误(400)'
            break
        case 401:
            message = '未授权，请重新登录(401)'
            break
        case 403:
            message = '拒绝访问(403)'
            break
        case 404:
            message = '请求出错(404)'
            break
        case 408:
            message = '请求超时(408)'
            break
        case 500:
            message = '服务器错误(500)'
            break
        case 501:
            message = '服务未实现(501)'
            break
        case 502:
            message = '网络错误(502)'
            break
        case 503:
            message = '服务不可用(503)'
            break
        case 504:
            message = '网络超时(504)'
            break
        case 505:
            message = 'HTTP版本不受支持(505)'
            break
        default:
            message = `连接出错(${status})!`
    }
    return `${message}，请检查网络或联系管理员！`
}

const service = axios.create({
    headers: {
        "Content-Type": 'application/json;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    timeout: 30000,
    
    validateStatus() {
      
        return true
    }

})


const pending = new Map()

const addPending = (config: AxiosRequestConfig) => {
    const url = [
        config.method,
        config.url,
    ].join('&')
    config.cancelToken = config.cancelToken || new axios.CancelToken((cancel: any) => {
        if (!pending.has(url)) {
            pending.set(url, cancel)
        }
    })
}
/**
 * 移除请求
 * @param {Object} config 
 */
const removePending = (config: AxiosRequestConfig) => {
    const url = [
        config.method,
        config.url,
    ].join('&')
    if (pending.has(url)) {
        const cancel = pending.get(url)
        cancel(url)
        pending.delete(url)
    }
}


export const clearPending = () => {
    for (const [url, cancel] of pending) {
        cancel(url)
    }
    pending.clear()
}

service.interceptors.request.use((config: AxiosRequestConfig) => {
    removePending(config)
    addPending(config)
    return config
}, (error: { data: { msg?: any } }) => {
    return Promise.resolve(error)
})

service.interceptors.response.use((response: AxiosResponse) => {
    removePending(response)
     __SEND_API_LOG(response)
    const status = response.status
    const data = response.data
    if (status < 200 || status >= 300) {
        alert(showStatus(status));
        return Promise.reject(response)
    }
    if ((data.errno == 10001||data.code == 20000) && data.body.redirectUrl) {
        let linkStr = '?'
        if (data.body.redirectUrl.indexOf('?') > 0) {
            linkStr = '&'
        }
        window.location.href = data.body.redirectUrl + linkStr + 'context_url=' + encodeURIComponent(window.location.href)
    } 
   
    return data
})

export default service
